import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PagerList, GlobalInfo, FPMessage, Severities, PageKey, RoleAccess } from './../shared.model';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { BaseComponent } from './../base.component';
import { SharedService, Status, RowsPerOptions } from './../shared.service';
import { ConfirmationService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { CapitalizeFirstPipe } from './../pipes/custom-pipes.pipe';
import { ApprovalQueueService } from './../../queues/approval-queue/approval-queue.service';
import { RouteParams, ClosePopup, ApprovalQueue, ApprovalJobModel, RevertApprovalHistory, Reject } from './../../queues/approval-queue/approval-queue.model';

@Component({
    selector: 'reject-approval-popup',
    templateUrl: 'reject-approval.component.html'
})

export class RejectApprovalComponent extends BaseComponent implements OnInit {

    gi = new GlobalInfo;
    message = new FPMessage;
    popupClose = new ClosePopup;
    rp = new RouteParams;

    frmRejectApproval: FormGroup;
    rejectApproval = new ApprovalJobModel();
    rejectApprovalHistory: RevertApprovalHistory[];
    @Input() selectedRejectq: any[] = [];
    @Output() Close = new EventEmitter();
    @Input() isRevertHistory: boolean;
    Wojobid: number[] = [];
    //model initialize


    //variable declare
    submitted: boolean;
    loader: boolean;
    remarks: string;


    constructor(
        protected sharedService: SharedService,
        protected translate: TranslateService,
        private _approvalService: ApprovalQueueService,
        private _fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,      
        private confirmationService: ConfirmationService
    ) {

        super(sharedService, translate);
        this.gi = super.globalInfo();
    }

    ngOnInit() {

        this.getRouteParams();

        if(this.isRevertHistory)
        this.GetRejectApprovalHistory();

        this.frmRejectApproval = this._fb.group({
            Remarks: ['', Validators.required]
        })
    }

    getRouteParams(): void {
        this.route.queryParams.subscribe(params => {
            this.rp.WoJobId = params["idJ"];
            this.rp.WorkOrderId = params["idW"];
            this.rp.ServiceAddressId = params["idSa"];
            this.rp.BillingAddressId = params["idBa"];
            this.rp.WoCategoryId = params["idWoca"];
            this.rp.CustomerId = params["idCus"];
            this.rp.TimeZoneId = params["idTz"];
            this.rp.VendorName = params["nameV"];
            this.rp.TechnicianName = params["tName"];
            this.rp.TimeZoneDesc = params["descTi"];
            this.rp.CustTimeZoneDesc = params["custTimDesc"];
        });
    }

    GetRejectApprovalHistory() {
        this._approvalService.GetRejectApprovalHistory(this.gi.CompanyId, this.rp.WoJobId,
            this.rp.CustTimeZoneDesc)
            .subscribe(s => {
                this.rejectApprovalHistory = s
            });
    }

    updateRejectApproval(data: any, frmValid: boolean) {debugger;
        var reject = new Reject();
        this.Wojobid=[];
        this.submitted = true;
        if (frmValid) {
            this.confirmationService.confirm({
                message: this.translate.instant("REJECTAPPROVAL"),
                header: 'Submit Confirmation',
                icon: 'fa fa-trash',
                accept: () => {
                    this.remarks = data.Remarks;
                    this.loader = true;
                    if (this.selectedRejectq != null && this.selectedRejectq.length != 0 && this.selectedRejectq != undefined) {
                        this.selectedRejectq.map(m => {
                            this.Wojobid.push(m.wojobid);
                        });
                    }
                    else {
                        this.Wojobid.push(this.rp.WoJobId);
                    }

                    reject.CompanyId = this.gi.CompanyId;
                    reject.LoginId = this.gi.LoginId;
                    reject.CreatedSourceId = 1;
                    reject.Remarks = this.remarks;
                    reject.WoJobId = this.Wojobid;
                    reject.CreatedBy= this.gi.LoginId;

                    this._approvalService.updateRejectApproval(reject)
                        .subscribe(res => {

                            this.loader = false;
                            this.message = res.Message;
                            if (this.message.MessageCode == "1002") {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant("REJECTSUCCESS")
                                });
                                this.redirectToApprovalQueueList();                                
                            }
                            else {
                                this.sharedService.notification.emit({
                                    severity: Severities[this.message.Severity],
                                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                    detail: this.translate.instant(this.message.MessageCode)
                                });
                            }
                        });

                }
            });
        }
    }

    redirectToApprovalQueueList() {
        this.Close.emit(false);
        this.router.navigate(['/customview/ApprovalQueue']);
    }

    closePopup() {
        this.Close.emit(true);
    }
}
